module.exports = __webpack_public_path__ + "static/media/return-handling.d8a18f0e.svg";